import React from 'react'

import cn from 'classnames'

import { MetaText } from 'components/Typography'

import styles from './BaseInputMetaText.module.scss'
import { BaseInputMetaTextProps } from './types'

const BaseInputMetaText: React.FC<BaseInputMetaTextProps> = ({ isInvalid, id, children }) => {
  return (
    <MetaText
      Tag="p"
      role="alert"
      id={id}
      className={cn(styles.helperText, isInvalid && styles.helperText_invalid)}
    >
      {children}
    </MetaText>
  )
}

export default BaseInputMetaText
